import { createContext, useContext } from 'react';
import { useStore } from 'zustand';
export const FormContext = createContext(null);
export function useFormContext() {
    const context = useContext(FormContext);
    if (!context)
        throw new Error('useFormContext must be used within a FormProvider.');
    return context;
}
export function useFormStore() {
    return useFormContext().store;
}
export function useFormStoreSelector(selector) {
    return useStore(useFormStore(), selector);
}
export function useWidgets() {
    return useFormContext().widgets;
}
export function useForms() {
    return useFormContext().forms;
}
export function useRuntimeContext() {
    return useFormContext().runtimeContext;
}
export function useRuntimeContextValue(key) {
    return useFormContext().runtimeContext?.[key];
}
export function usePreviews() {
    return useFormContext().previews;
}
